<icc-list [searchable]="true" [items]="glazingBeads"
          [itemTemplate]="'itemImgTitle'"
          itemImgHeight="medium"
          (select)="selectBead($event)"></icc-list>
